import React from "react";
import { Form, Modal } from "react-bootstrap";
import { ReactComponent as Whiteclose } from "../../assets/images/white-close.svg";
import { Backdrop, CircularProgress, Drawer } from "@mui/material";
import { NotificationManager } from "react-notifications";
import validator from "validator";
import { connect } from "react-redux";
import { selectLoginStatus } from "../../store/signIn/signIn.selectors";
import { selectemployeeData } from "../../store/home/home.selectors";
import { bindActionCreators } from "redux";
import AppConfig from "../../config/app.config";
import UserService from "../../services/user/user.service";

const mapStateToProps = (state) => {
  return {
    selectLoginStatus: selectLoginStatus(state),
    employeeData: selectemployeeData(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators({}, dispatch),
});

class ResetPasswordOverlay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: 0,
      resetId: null,
      employeeId: null,
      resetKey: false,
      message: "",

      password: "",
      repeatedPassword: "",
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    if (this.props.employeeData?.employeeId != null) {
      this.props.close();
      this.props.history.push("/");
    } else {
      this.validateResetKey();
    }
  }

  handlePassword = (event) => {
    this.setState({ password: event.target.value });
  };
  handleRepeatedPassword = (event) => {
    this.setState({ repeatedPassword: event.target.value });
  };

  validateResetKey = () => {
    const resetKey = this.props.pathName?.split("/")[2];
    if (resetKey !== "" && resetKey != null) {
      const payload = {
        resetKey: resetKey,
      };
      this.setState({ isLoading: 1 });
      UserService.validateResetKey(payload)
        .then((res) => {
          if (res.error != null) {
            const errorMessage =
              typeof res.error?.response?.data === "string" ||
              res.error?.response?.data instanceof String
                ? res.error?.response?.data
                : res.error?.response?.data?.message;
            NotificationManager.error(errorMessage, "", 2000);
            this.timeoutHandle = setTimeout(() => {
              this.setState({
                isLoading: 0,
                resetId: null,
                employeeId: null,
                resetKey: false,
                message: errorMessage,
                password: "",
                repeatedPassword: "",
              });
              this.props.close();
              this.props.history.push("/");
            }, 3000);
          } else {
            if (res["status"]) {
              const data = res["data"] != null ? res["data"][0] : res["data"];
              if (data != null) {
                const employee = data.employeeList?.find(
                  (emp) => emp.sphereTypeId === AppConfig.API.SPHERE_TYPE_ID
                );
                this.setState({
                  isLoading: 0,
                  resetId: data.resetId,
                  employeeId: employee?.employeeId,
                  resetKey: true,
                  message: res["message"],
                });
              }
            } else {
              NotificationManager.error(res["message"], "", 2000);
              this.timeoutHandle = setTimeout(() => {
                this.setState({
                  isLoading: 0,
                  resetId: null,
                  employeeId: null,
                  resetKey: false,
                  message: res["message"],
                });
                this.props.close();
                this.props.history.push("/");
              }, 3000);
            }
          }
        })
        .catch((err) => {
          NotificationManager.error(err, "", 2000);
          this.timeoutHandle = setTimeout(() => {
            this.setState({
              isLoading: 0,
              resetId: null,
              employeeId: null,
              resetKey: false,
              message: err,
            });
            this.props.close();
            this.props.history.push("/");
          }, 3000);
        });
    } else {
      NotificationManager.error("Reset Key is not valid.", "", 2000);
      this.timeoutHandle = setTimeout(() => {
        this.setState({
          resetId: null,
          employeeId: null,
          resetKey: false,
          message: "Reset Key is not valid.",
        });
        this.props.close();
        this.props.history.push("/");
      }, 3000);
    }
  };

  saveResetPassword = () => {
    if (this.state.resetId != null && this.state.employeeId != null) {
      if (this.state.password === "") {
        NotificationManager.warning("Please Enter Password.", "", 2000);
      } else if (!validator.isStrongPassword(this.state.password)) {
        NotificationManager.warning(
          "Password must contain at least 8 characters, including 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character.",
          "",
          2000
        );
      } else if (this.state.repeatedPassword === "") {
        NotificationManager.warning("Please Enter Confirm Password.", "", 2000);
      } else if (this.state.repeatedPassword !== this.state.password) {
        NotificationManager.warning(
          "New password and confirm password do not match.",
          "",
          2000
        );
      } else {
        const payload = {
          password: this.state.password,
          employeeIds: [this.state.employeeId],
          resetId: this.state.resetId,
        };
        this.setState({ isLoading: 1 });
        UserService.saveNewPassword(payload)
          .then((res) => {
            if (res.error != null) {
              if (res.error?.response?.data?.message != null) {
                NotificationManager.error(
                  res.error.response.data.message,
                  "",
                  2000
                );
              } else {
                NotificationManager.error(
                  "Could not update password.",
                  "",
                  2000
                );
              }
              this.timeoutHandle = setTimeout(() => {
                this.setState({
                  isLoading: 0,
                  password: "",
                  repeatedPassword: "",
                  resetId: null,
                  employeeId: null,
                  resetKey: false,
                });
                this.props.close();
                this.props.showSigninOverlay();
                this.props.history.push("/");
              }, 3000);
            } else {
              if (res["status"]) {
                NotificationManager.success(
                  "Password Reset Successfully.",
                  "",
                  2000
                );
                this.timeoutHandle = setTimeout(() => {
                  this.setState({
                    isLoading: 0,
                    resetId: null,
                    employeeId: null,
                    resetKey: false,
                    message: "",
                    password: "",
                    repeatedPassword: "",
                  });
                  this.props.close();
                  this.props.showSigninOverlay();
                  this.props.history.push("/");
                }, 3000);
              } else {
                NotificationManager.error(res["message"], "", 2000);
                this.timeoutHandle = setTimeout(() => {
                  this.setState({
                    isLoading: 0,
                    resetId: null,
                    employeeId: null,
                    resetKey: false,
                    password: "",
                    repeatedPassword: "",
                  });
                  this.props.close();
                  this.props.showSigninOverlay();
                  this.props.history.push("/");
                }, 3000);
              }
            }
          })
          .catch((err) => {
            NotificationManager.error(err, "", 2000);
            this.timeoutHandle = setTimeout(() => {
              this.setState({
                isLoading: 0,
                resetId: null,
                employeeId: null,
                resetKey: false,
                password: "",
                repeatedPassword: "",
              });
              this.props.close();
              this.props.showSigninOverlay();
              this.props.history.push("/");
            }, 3000);
          });
      }
    }
  };

  render() {
    return (
      <>
        <Modal
          enforceFocus={false}
          show={this.props.visible}
          onHide={() => {
            this.setState({
              isLoading: 0,
              resetId: null,
              employeeId: null,
              resetKey: false,
              message: "",
              password: "",
              repeatedPassword: "",
            });
            this.props.close();
            this.props.history.push("/");
          }}
          backdrop="static"
          keyboard={false}
          centered
          id="signin-modal"
        >
          {this.state.isLoading === 1 && (
            <Backdrop style={{ zIndex: 9999999, color: "#fa96c8" }} open>
              <CircularProgress color="inherit" />
            </Backdrop>
          )}
          <div className="mobile-registration">
            <div className="mobile-register">
              <p>Reset Password</p>
              <Whiteclose
                className="closeicon"
                onClick={() => {
                  this.setState({
                    isLoading: 0,
                    resetId: null,
                    employeeId: null,
                    resetKey: false,
                    message: "",
                    password: "",
                    repeatedPassword: "",
                  });
                  this.props.close();
                  this.props.history.push("/");
                }}
              />
            </div>
            <div className="mobile-registration">
              <div className="mobile-register-details">
                <img
                  src={require("../../assets/images/electrified-black.png")}
                  alt="logo"
                  className="black-logo"
                ></img>
                <Form.Group>
                  <label className="label">Password</label>
                  <Form.Control
                    type="password"
                    className="register-email"
                    placeholder="password"
                    value={this.state.password}
                    onChange={this.handlePassword}
                    autoComplete="off"
                    required
                  />
                </Form.Group>
                <Form.Group>
                  <label className="label">Confirm Password</label>
                  <Form.Control
                    type="password"
                    className="register-email"
                    placeholder="confirm password"
                    value={this.state.repeatedPassword}
                    onChange={this.handleRepeatedPassword}
                    autoComplete="off"
                    required
                  />
                </Form.Group>
                <button
                  onClick={this.saveResetPassword}
                  type="button"
                  className="header-mob-btn"
                  id="Send-ResetLink"
                >
                  Change Password
                </button>
              </div>
            </div>
          </div>
        </Modal>

        <Drawer
          anchor="right"
          open={this.props.visible}
          onClose={() => {
            this.setState({
              isLoading: 0,
              resetId: null,
              employeeId: null,
              resetKey: false,
              message: "",
              password: "",
              repeatedPassword: "",
            });
            this.props.close();
            this.props.history.push("/");
          }}
          id="set-mob-drawer"
        >
          {this.state.isLoading === 1 && (
            <Backdrop style={{ zIndex: 9999999, color: "#fa96c8" }} open>
              <CircularProgress color="inherit" />
            </Backdrop>
          )}

          <div id="togglemenu-mobile">
            <div className="close-icon">
              <Whiteclose
                className="drawerclose-icon"
                onClick={() => {
                  this.setState({
                    isLoading: 0,
                    resetId: null,
                    employeeId: null,
                    resetKey: false,
                    message: "",
                    password: "",
                    repeatedPassword: "",
                  });
                  this.props.close();
                  this.props.history.push("/");
                }}
              />
            </div>
            <div className="mobile-registration">
              <div className="mobile-register">
                <p>Reset Password</p>
              </div>
              <div className="mobile-registration" id="mobile-signin">
                <div className="mobile-register-details">
                  <img
                    src={require("../../assets/images/electrified-black.png")}
                    alt="logo"
                    className="black-logo"
                  />
                  <Form.Group>
                    <label className="label">Password</label>
                    <Form.Control
                      type="password"
                      className="register-email"
                      placeholder="password"
                      value={this.state.password}
                      onChange={this.handlePassword}
                      autoComplete="off"
                      required
                    />
                  </Form.Group>
                  <Form.Group>
                    <label className="label">Confirm Password</label>
                    <Form.Control
                      type="password"
                      className="register-email"
                      placeholder="confirm password"
                      value={this.state.repeatedPassword}
                      onChange={this.handleRepeatedPassword}
                      autoComplete="off"
                      required
                    />
                  </Form.Group>
                  <button
                    onClick={this.saveResetPassword}
                    type="button"
                    className="header-mob-btn"
                  >
                    Change Password
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Drawer>
      </>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResetPasswordOverlay);
